import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
import { ServicesProvider } from 'src/providers/services';
import { DatePikerPage } from '../../date-piker/date-piker.page';
import { MediapopupPage } from 'src/app/mediapopup/mediapopup.page';


@Component({
  selector: 'app-defined-duties',
  templateUrl: './defined-duties.page.html',
  styleUrls: ['./defined-duties.page.scss'],
})
export class DefinedDutiesPage implements OnInit {

  calendor: boolean = false;
  dateRange: any;
  Nurse_ID: any;
  allNurseDuties: any = [];
  Nurse_Name: any;
  Nurse_Profile: any;
  fromDate: any
  selectedDate: any;
  Date: any = new Date();
  searchDate: any;
  excluded_dates: any;
  pageNo: number = 1;
  EmptyData: any;
  refEvent: any;
  particularProfile: any;
  messageContent: any;
  presentView :any;
  titleContent: any;

  constructor(private datePipe: DatePipe, public modalCtrl: ModalController,
    public addCall: AddCall, public router: Router, private services: ServicesProvider) { }

  ngOnInit() {

    console.log(this.Nurse_ID, "nurse_id", this.Nurse_Name, this.Nurse_Profile);
  }

  ionViewWillEnter() {
    debugger
    console.log(this.messageContent,"13345689",this.titleContent);
    this.presentView = 'nurse';
    this.presentView = this.titleContent;
    this.particularProfile = this.messageContent;
    let getDate = new Date();
    let currentDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    this.getnurseduty(currentDate);
    this.searchDate = currentDate;
  }
  back() {
    this.modalCtrl.dismiss();
  }

  async calshow() {
    debugger
    this.calendor = true;
    // this.changeMonth = new Date();
    this.changeMonth = new Date(this.excluded_dates.from_date);
    let dateArray = String(this.changeMonth).split(' ');
    this.nurseYear = dateArray[3];
    this.nurseMonth = dateArray[1];
    let fromDate = "2024-08-01"
    let toDate = "2024-10-01"
    this.getBkgDateCale(new Date(fromDate), new Date(toDate))
    const modal = await this.modalCtrl.create({
      component: MediapopupPage,
      cssClass: 'service-model-nurse',
      componentProps: {
        Nurse_Calender: 'Nurse',
        excluded_datess: this.excluded_dates.excluded_date,
        fromDate: '2024-08-01',
        toDate: '2024-10-01',
        nurseMonth: dateArray[1],
        nurseYear: dateArray[3],
        changeMonth: this.changeMonth,
        dutyFromDate: this.excluded_dates.from_date,
        dutyToDate: this.excluded_dates.to_date,
      },
    });
    return await modal.present();

  }
  formatDates(newdate:any){
    const date = new Date(newdate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  doRefresh(event: any, value: any) {
    debugger;
    // let getDate = new Date();
    // let currentDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    this.getnurseduty(this.searchDate);
    this.refEvent = event;
  }


  // async doRefresh(event: any, value: any) {
  //   const getDate = new Date();
  //   const currentDate = `${getDate.getFullYear()}-${("0" + (getDate.getMonth() + 1)).slice(-2)}-${("0" + getDate.getDate()).slice(-2)}`;
  //   try {
  //     await this.getnurseduty(currentDate);
  //   } catch (error) {
  //     console.error('Error fetching nurse duties:', error);
  //   } finally {
  //     event.target.complete();
  //   }
  //   this.refEvent = event;
  // }

  getnurseduty(data) {
    try {
      const requestdata = JSON.stringify({
        nurseId: this.Nurse_ID,
        dutyDate: data,
        selectedDate: new Date()
      });

      this.services.postRequestNurse('getnurseduty', requestdata).subscribe(response => {
        console.log(response, "nurseduty");
        if (this.refEvent) {
          this.refEvent.target.complete();
        }
        if (response.data.length > 0 && response.status == 1) {
          this.allNurseDuties = response.data[0].nurseDuties;
          this.excluded_dates = response.data[0];
          console.log('Length => ', this.allNurseDuties, this.excluded_dates);
        }
        else {
          this.allNurseDuties = [];
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }
    let Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substring(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? "AM" : "PM";
        let timeString = h + String(Value).substring(hourEnd, 5) + " " + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }
        return timeString;
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy")
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }


  async openDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': new Date(this.fromDate),
        'calenderType': "normal",
        "messageFromNurse": "nurseDateof",
        curdate: new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]
      }
    })
    await datePickerModal.present()

    datePickerModal.onDidDismiss()
      .then((data) => {
        if (data.data) {
          let Date = data.data
          this.fromDate = Date.getFullYear() + "-" + ("0" + (Date.getMonth() + 1)).slice(-2) + "-" + ("0" + (Date.getDate())).slice(-2)
        }
      })
  }

  dateIncDec(incOrDec) {
    if (incOrDec == 'inc') {
      let date = null;
      date = new Date(this.Date);
      date.setDate(date.getDate() + 1);
      this.Date = date;
      this.searchDate =
        this.Date.getFullYear() +
        '-' +
        ('0' + (this.Date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + this.Date.getDate()).slice(-2);
      this.getnurseduty(this.searchDate);

    } else if (incOrDec == 'dec') {
      if (this.Date >= new Date()) {
        let date = null;
        date = new Date(this.Date);
        date.setDate(date.getDate() - 1);
        this.Date = date;
        this.searchDate =
          this.Date.getFullYear() +
          '-' +
          ('0' + (this.Date.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + this.Date.getDate()).slice(-2);
        this.getnurseduty(this.searchDate);
      }
    }
    this.addCall.changeDateLan(this.Date);
  }


  // =========================================================================================================
  storeDates: any = [];
  excludedDate: any = [];
  completedDays: any = [];
  pendingDays: any = [];

  getBkgDateCale(fromDate, toDate) {

    this.excludedDate = [];
    let compDays = [];
    let pendDays = [];

    compDays.forEach((item) => {
      this.completedDays.push(this.dateConvertion(item))
    });
    pendDays.forEach((item) => {
      this.pendingDays.push(this.dateConvertion(item))
    });

    console.log("his.completedDays", this.completedDays);
    console.log("his.completedDays", this.pendingDays);

    debugger
    this.storeDates = [];
    const FromDate = new Date(fromDate);
    const ToDate = new Date(toDate);
    let exStatus = false;

    let prevDate = new Date(FromDate.getFullYear(), FromDate.getMonth(), 0).getDay();
    console.log("prevDate", prevDate);
    if (prevDate < 6) {
      for (let i = prevDate; i >= 0; i--) {
        this.storeDates.push({
          fullDate: " ",
          year: " ",
          month: " ",
          date: " ",
          excldDate: exStatus
        });
      }
    }
    console.log("?joy", this.storeDates);

    let monthEnd = new Date(FromDate.getFullYear(), FromDate.getMonth() + 1, 0).getDate();
    console.log("monthEnd=>", monthEnd);
    for (let i = 1; i <= monthEnd; i++) {
      for (let item of this.excludedDate) {
        let eD = new Date(item);
        let exDate = new Date(eD.getFullYear(), eD.getMonth(), eD.getDate()).toDateString();
        let date = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString();
        if (exDate == date) {
          exStatus = true;
          break;
        }
        else {
          exStatus = false;
        }
      }
      this.storeDates.push({
        fullDate: new Date(FromDate.getFullYear(), FromDate.getMonth(), i),
        year: FromDate.getFullYear(),
        month: FromDate.getMonth() + 1,
        date: i,
        excldDate: exStatus
      });
      exStatus = false;
    }
    console.log("storeDate=>", this.storeDates);
  }


  dateConvertion(data) {
    let date = new Date(data);
    date.setHours(0, 0, 0, 0);
    let formattedDate = date.toString();
    return formattedDate;
  }


  isCompleted(dateOf: any): boolean {
    if (dateOf != " " && dateOf != undefined) {
      var changedDate = this.formatDate(dateOf)
    } else {
      changedDate = dateOf
    }
    let foundValue;
    foundValue = this.completedDays.find(
      (element) => element === changedDate
    );
    return foundValue;
  }

  isPending(dateOf: any): boolean {
    if (dateOf != " " && dateOf != undefined) {
      var changedDate = this.formatDate(dateOf)
    } else {
      changedDate = dateOf
    }
    let foundValue;
    foundValue = this.pendingDays.find(
      (element) => element === changedDate
    );
    return foundValue;
  }

  formatDate(date) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours = '00';
    const minutes = '00';
    const seconds = '00';
    const formattedDate = `${dayName} ${monthName} ${day} ${year} ${hours}:${minutes}:${seconds} GMT+0530 (India Standard Time)`;

    return formattedDate;
  }


  changeMonth: any;
  next() {
    debugger
    let nowDate = new Date(this.changeMonth);
    let nextMonth = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 1);
    let dateArray = String(nextMonth).split(' ');
    this.nurseYear = dateArray[3];
    this.nurseMonth = dateArray[1];
    this.getBkgDateCale(new Date(nextMonth), new Date(nextMonth));
    this.changeMonth = nextMonth;
  }
  nurseYear: any;
  nurseMonth: any;
  prev() {
    let nowDate = new Date(this.changeMonth);
    let nextMonth = new Date(nowDate.getFullYear(), nowDate.getMonth() - 1, 1);
    let dateArray = String(nextMonth).split(' ');
    this.nurseYear = dateArray[3];
    this.nurseMonth = dateArray[1];
    this.getBkgDateCale(new Date(nextMonth), new Date(nextMonth));
    this.changeMonth = nextMonth;
  }



}
